import * as React from 'react';
import { DateTime } from '@grandvisionhq/common';

const BlogMeta = ({ publishDate , readingTime =0 , minutesLabel , locale  })=>{
    const hasReadingTime = readingTime && readingTime > 0 && minutesLabel;
    if (!publishDate) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "blog-meta"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "blog-meta__date"
    }, /*#__PURE__*/ React.createElement(DateTime, {
        dateTime: publishDate,
        locale: locale
    })), hasReadingTime && /*#__PURE__*/ React.createElement("span", {
        className: "blog-meta__minutes"
    }, `- ${readingTime.toString()} ${minutesLabel}`));
};

export { BlogMeta as default };
//# sourceMappingURL=BlogMeta.js.map
